import axios from 'axios'

export default {
  getUserDetails () {
    return axios.get('/api/digital-catalog/user-details')
  },
  submitSelectedProducts (productIds) {
    return axios.post('/api/digital-catalog/selected-products', {
        product_ids: productIds
    })
  },
  addProductsQuantity(payload, accessToken) {
    return axios.post('/api/digital-catalog/add-products-quantity', payload, {
        headers: {
            'X-Access-Token': accessToken
        }
    })
  },
  duplicateProductsQuantities(payload, accessToken) {
    return axios.post('/api/digital-catalog/duplicate-products-quantities', payload, {
      headers: {
        'X-Access-Token': accessToken
      }
    })
  },
  addProductNotes(payload, accessToken) {
    return axios.post('/api/digital-catalog/add-product-notes', payload, {
        headers: {
            'X-Access-Token': accessToken
        }
    })
  },
  deleteProductNotes(payload, accessToken) {
    return axios.post('/api/digital-catalog/delete-product-notes', payload, {
        headers: {
            'X-Access-Token': accessToken
        }
    })
  },
  placeOrder(payload, accessToken) {
    return axios.post('/api/digital-catalog/place-order', payload, {
        headers: {
            'X-Access-Token': accessToken
        }
    })
  },
  removeProduct(payload, accessToken) {
    return axios.post('/api/digital-catalog/remove-product', payload, {
        headers: {
            'X-Access-Token': accessToken
        }
    })
  }
}
